import ServiceFactory from "../service";

// Workspace brand kit (Settings → Brand kit; GET/PUT /v1/reports/brand — under
// the reports prefix because the gateway proxies it). One loader so every
// consumer (report sheet preview, automation editor, settings page) reads the
// same shape: { logoUrl, accent, company, footer, website, mailingAddress,
// defaultCompany, customized, canEdit }.
export function brandSvc() {
  const S = ServiceFactory.getType("/reports/brand", "product");
  return new S();
}
let _cache = null;
export async function loadBrandKit(force) {
  if (_cache && !force) return _cache;
  try {
    _cache = (await brandSvc().getAsync()) || {};
  } catch (e) {
    _cache = {};
  }
  return _cache;
}
export function invalidateBrandKit() {
  _cache = null;
}

// Merge fields every email surface exposes (same {{key}} syntax as contact attributes).
export const BRAND_MERGE_FIELDS = [["{{brandLogoUrl}}", "Logo URL from the brand kit"], ["{{brandCompany}}", "Company display name"], ["{{brandAccent}}", "Accent color (hex)"], ["{{brandMailingAddress}}", "Mailing address (CAN-SPAM)"], ["{{brandWebsite}}", "Website"], ["{{brandFooter}}", "Footer line"]];